import React from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- replace with crystal-ui
import { Snackbar as SnackbarComponent, Alert } from '@applyboard/ui-components';
import { useFormState } from "../FormStateProvider";
export var Snackbar = function Snackbar(_ref) {
  var openSnackbar = _ref.openSnackbar,
    message = _ref.message;
  var _useFormState = useFormState(),
    onHideError = _useFormState.onHideError;
  return /*#__PURE__*/React.createElement(SnackbarComponent, {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    open: openSnackbar,
    onClose: onHideError,
    autoHideDuration: null
  }, /*#__PURE__*/React.createElement(Alert, {
    severity: "error",
    onClose: onHideError,
    "aria-label": message
  }, message));
};